// Translation keys for aspire.constants.profilePictureFeedback

import React from 'react'
// feedbackMap now a function that takes intl
export const feedbackMap = (intl) => ({
  face_frame_ratio: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceFrameRatio.good',
      defaultMessage: 'You have done a good job of maintaining face/frame ratio of around 50%.',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceFrameRatio.try',
      defaultMessage: 'Try to maintain a face/frame ratio of around 50%.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceFrameRatio.try',
      defaultMessage: 'Try to maintain a face/frame ratio of around 50%.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceFrameRatio.unable',
      defaultMessage: 'Unable to detect. A good image has a face/frame ratio of around 50%.',
    }),
  },
  background: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.background.good',
      defaultMessage: 'Your profile picture has a clear background. Good job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.background.try',
      defaultMessage: 'Make sure your picture has a clear background.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.background.try',
      defaultMessage: 'Make sure your picture has a clear background.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.background.unable',
      defaultMessage: 'Unable to detect. A good image should have a clear background.',
    }),
  },
  foreground: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.foreground.good',
      defaultMessage: 'The objects in your photo do not interfere with clarity and prominence of face. Good job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.foreground.try',
      defaultMessage: 'Make sure that objects in your photo do not interfere with clarity and prominence of face.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.foreground.try',
      defaultMessage: 'Make sure that objects in your photo do not interfere with clarity and prominence of face.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.foreground.unable',
      defaultMessage: 'Unable to detect. Objects in the photo should not interfere with clarity and prominence of face.',
    }),
  },
  resolution: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.resolution.good',
      defaultMessage: 'Your photo size is within the specified limits of 400 x 400 and 20K x 20K pixels. Good job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.resolution.try',
      defaultMessage: 'Make sure that your photo size is within the specified limits of 400 x 400 and 20K x 20K pixels.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.resolution.try',
      defaultMessage: 'Make sure that your photo size is within the specified limits of 400 x 400 and 20K x 20K pixels.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.resolution.unable',
      defaultMessage: 'Unable to detect. Photo size should be between 400 x 400 and 20K x 20K pixels.',
    }),
  },
  symmetry: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.symmetry.good',
      defaultMessage: 'Your face and shoulders are turned just right!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.symmetry.try',
      defaultMessage: 'Your face is turned too far.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.symmetry.try',
      defaultMessage: 'Your face is turned too far.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.symmetry.unable',
      defaultMessage: 'Unable to detect. Face and shoulders should be angled approrpiately to the camera.',
    }),
  },
  face_body_ratio: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceBodyRatio.good',
      defaultMessage: 'Your profile picture has an appropriate face to body ratio. Good Job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceBodyRatio.try',
      defaultMessage: 'Ensure that your face covers more area in your picture as compared to your body.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceBodyRatio.try',
      defaultMessage: 'Ensure that your face covers more area in your picture as compared to your body.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.faceBodyRatio.unable',
      defaultMessage: 'Unable to detect. Ensure that your face covers more area as compared to your body.',
    }),
  },
  professional_clothes: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.professionalClothes.good',
      defaultMessage: 'A suit and tie are suave and professional attire. Good job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.professionalClothes.try',
      defaultMessage: 'A suit and tie are suave and professional attire.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.professionalClothes.try',
      defaultMessage: 'A suit and tie are suave and professional attire.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.professionalClothes.unable',
      defaultMessage: 'Unable to detect. A suit and tie are suave and professional attire.',
    }),
  },
  pupil: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.pupil.good',
      defaultMessage: 'You have done a good job of maintaining eye contact with the camera.',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.pupil.try',
      defaultMessage: 'Try to make eye contact with the camera.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.pupil.try',
      defaultMessage: 'Try to make eye contact with the camera.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.pupil.unable',
      defaultMessage: 'Unable to detect. One should make an eye contact with the camera.',
    }),
  },
  smile: {
    green: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.smile.good',
      defaultMessage: 'An open smile is more likeable. Good Job!',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.smile.try',
      defaultMessage: 'Try to have a more open smile as it increases likeability.',
    }),
    red: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.smile.try',
      defaultMessage: 'Try to have a more open smile as it increases likeability.',
    }),
    gray: intl.formatMessage({
      id: 'aspire.profilePictureFeedback.smile.unable',
      defaultMessage: 'Unable to detect. Try to have a more open smile.',
    }),
  },
})

// iconMap and colorMap are not user-facing, so no change needed
export const iconMap = {
  green: 'icon-good-job.svg',
  yellow: 'icon-on-track.svg',
  red: 'icon-needs-work.svg',
}

export const colorMap = {
  green: 'circle-green',
  yellow: 'circle-yellow',
  red: 'circle-red',
  gray: 'color-gray',
}

// symbolMap is UI, not user-facing text, so no change needed
export const symbolMap = {
  green: <span className="fa fa-check" aria-hidden="true" />,
  yellow: <span className="fa fa-exclamation" aria-hidden="true" />,
  red: <span className="fa fa-times" aria-hidden="true" />,
}
